class YourStoreFacet extends HTMLElement {
    constructor() {
        super();

        this.yourStoreModalOpener = document.querySelectorAll('.your-store-modal__button');
        this.yourStoreModal = document.querySelector('your-store-modal');

        this.currentStoreEl = this.querySelector('.facet-way__current');

        // Check local storage for 'storeWay', default to 'all' if not found
        this.way = localStorage.getItem('storeWay') || 'all';

        // Check local storage for 'storeState', default to 'MN' if not found
        this.state = localStorage.getItem('storeState') || 'MN';

        // Check local storage for 'storeLocation', default to null if not found
        this.store = localStorage.getItem('storeLocation') || null;

        // Check local storage for 'storeAvailability', default to null if not found
        this.availability = localStorage.getItem('storeAvailability') || null;

        // Loading indicator
        this.loadingIndicator = this.querySelector('.facet-store-selector__loader');

        this.initialize = this.initialize.bind(this);
    }

    connectedCallback() {
        // Initialize hidden filters
        this.initHiddenFilters();

        // Initialize the component based on the current values of this.way, this.state, and this.store
        this.initialize();

        // Get filter counts
        this.setFacetCounts();

        // Update remove all links
        this.updateRemoveAllUrl();
    }

    initHiddenFilters() {
        // Convert NodeList to Array
        this.wayButtons = Array.from(this.querySelectorAll('[data-way]'));

        // Add event listeners to the way buttons
        this.wayButtons.forEach((button) => {
            button.addEventListener('click', this.handleWayClick.bind(this));
        });

        // Currently selected store
        this.currentlySelectedStoreWayEl = this.querySelector('[data-facet-current-store]');

        // Currently selected store
        this.currentlySelectedStoreEl = this.querySelector('.facet-way__current');

        this.availabilityRadiosWrapper = this.querySelector('.facet-way__sub-options');

        // Convert NodeList to Array
        this.availabilityRadios = Array.from(this.querySelectorAll('[data-store-availability]'));

        // Add event listeners to the pickup type radio buttons
        this.availabilityRadios.forEach((radioButton) => {
            radioButton.addEventListener('click', this.handleAvailabilityClick.bind(this));
        });

        // Get the shop online, pickup in store filter
        this.shopOnlineFilter = document.querySelector(
            'details[data-name="shop-online-pickup-in-store"]'
        );

        // Get the view in store filter
        this.viewInStoreFilter = document.querySelector('details[data-name="view-in-store"]');

        // Get the view in store filter
        this.shippableFilter = document.querySelector(
            'details[data-name="shippable-has-quantity"]'
        );

        this.resetAllButton = document.querySelector('#reset-all');
    }

    /**
     * Initializes the component based on the current values of this.way, this.state, and this.store.
     * Finds the corresponding buttons and radio buttons based on the current values and clicks them.
     * Then, it updates the modal opener and location filter.
     *
     * @returns {void}
     */
    initialize() {
        // Find the button with the matching 'data-way' attribute value and click it
        const wayButton = this.wayButtons.find(
            (button) => button.getAttribute('data-way') === this.way
        );

        if (wayButton) {
            wayButton.classList.add('active-way');
        }

        const availabilityRadioButton = this.availabilityRadios.find(
            (radioButton) => radioButton.dataset.storeAvailability === this.availability
        );

        if (availabilityRadioButton) {
            availabilityRadioButton.classList.add('active-option');
        }

        let hasAvailability = false;
        if (this.way == 'pickup' && this.availability) {
            hasAvailability = this.checkAvailabilityOptions();
            if (hasAvailability) {
                this.availabilityRadiosWrapper.classList.remove('hidden');
            }
        }

        if (this.currentlySelectedStoreEl && this.yourStoreModalOpener) {
            this.currentlySelectedStoreEl.addEventListener(
                'click',
                function () {
                    this.yourStoreModalOpener[0].click();
                    this.yourStoreModal.querySelector('button[data-way="pickup"]').click();
                }.bind(this)
            );
        }

        // Hide the loading indicator
        this.hideLoadingIndicator();
    }

    checkAvailabilityOptions() {
        const shopOnlinePickupInStore = document.querySelector(
            '[data-name="shop-online-pickup-in-store"]'
        );
        const viewInStore = document.querySelector('[data-name="view-in-store"]');

        // Return false if either element doesn't exist
        if (!shopOnlinePickupInStore || !viewInStore) return false;

        // Get all checkboxes from both sections
        const shopOnlineCheckboxes =
            shopOnlinePickupInStore.querySelectorAll('input[type="checkbox"]');
        const viewInStoreCheckboxes = viewInStore.querySelectorAll('input[type="checkbox"]');

        // Helper function to check if there are any enabled checkboxes
        const hasEnabledCheckboxes = (checkboxes) => {
            for (const checkbox of checkboxes) {
                if (!checkbox.disabled) {
                    return true; // Found an enabled checkbox
                }
            }
            return false; // No enabled checkboxes found
        };

        // Return true if either section has enabled checkboxes
        return (
            hasEnabledCheckboxes(shopOnlineCheckboxes) ||
            hasEnabledCheckboxes(viewInStoreCheckboxes)
        );
    }

    /**
     * Handles the way click event.
     * Updates the value of this.way based on the selected button.
     *
     * @param {Event} event - The click event.
     * @returns {void}
     */
    handleWayClick(event) {
        const buttonEl = event.target;

        // Get the data-way attribute value of the clicked button
        const way = buttonEl.getAttribute('data-way');

        // Update the this.way variable with the new way value
        this.way = way;
        const activeClass = 'active-way';

        // Get the parent div of the clicked button
        const parentWay = buttonEl.closest('.facet-store-selector__ways-v2');

        if (this.way != 'pickup') {
            // Find the currently active button with 'button--primary' class
            const activeButton = parentWay.querySelector('.' + activeClass);

            // If there is an active button, remove 'button--primary' and add 'button--secondary'
            if (activeButton) {
                activeButton.classList.remove(activeClass);
            }

            // Remove 'button--secondary' from the clicked button and add 'button--primary'
            buttonEl.classList.add(activeClass);
        }

        if (
            this.way == 'pickup' &&
            // this.store == null &&
            this.yourStoreModalOpener.length &&
            this.yourStoreModal
        ) {
            if (!this.store) {
                this.yourStoreModalOpener[0].click();
                this.yourStoreModal.querySelector('button[data-way="pickup"]').click();
            } else {
                this.yourStoreModal.querySelector('button[data-way="pickup"]').click();
                this.yourStoreModal
                    .querySelector(`[data-pickup-store][value="${this.store}"]`)
                    .click();
            }
        } else if (this.way == 'online') {
            // Update the local storage variable storeWay to online
            localStorage.setItem('storeWay', 'online');

            // Remove the local storage variables storeLocation, storeAvailability, and storeState
            localStorage.removeItem('storeAvailability');
            localStorage.removeItem('storeState');

            this.handleOnline();
        } else if (this.way == 'all') {
            // Update the local storage variable storeWay to all
            localStorage.setItem('storeWay', 'all');
            this.resetToAll();
        }

        this.yourStoreModal.showSuccessNotice();
    }

    handleOnline() {
        const currentUrl = new URL(window.location.href);
        const shippableQtyCheckbox = this.shippableFilter.querySelector('input[value="1"]');

        // *** if there's existing location checked, we must
        // *** clear them first by stripping the filter parameters
        // *** in the URL then re-clicking the 'Online' in the
        // *** 'Product Availability' filter on reload
        if (
            currentUrl.searchParams.has('filter.v.m.p80.pickup_in_store') ||
            currentUrl.searchParams.has('filter.v.m.p80.view_in_store')
        ) {
            this.viewInStoreFilter
                .querySelectorAll('input[type="checkbox"]')
                .forEach((checkbox) => {
                    checkbox.checked = false;
                });
            this.shopOnlineFilter.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
                checkbox.checked = false;
            });
            setTimeout(() => {
                shippableQtyCheckbox.click();
            }, 500);
        } else if (shippableQtyCheckbox && !shippableQtyCheckbox.checked) {
            shippableQtyCheckbox.click();
        }

        const headerModalOpener = document.querySelector('.header__your-store-opener');
        if (headerModalOpener) {
            headerModalOpener.querySelector('button').setAttribute('data-way', 'online');
        }

        // Close Filter in mobile
        this.yourStoreModal.hideMobileFilterDrawer();
    }

    /**
     * Handles the pickup type radio button click event.
     * Updates the value of this.store based on the selected radio button.
     *
     * @param {Event} event - The click event.
     * @returns {void}
     */
    handleAvailabilityClick(event) {
        const availabilityButton = event.target;

        // Get the value of the clicked radio button
        const storeAvailability = availabilityButton.dataset.storeAvailability;

        // Save the storeAvailability variable in local storage
        localStorage.setItem('storeAvailability', storeAvailability);

        if (storeAvailability == 'pickup') {
            this.viewInStoreFilter
                .querySelectorAll('input[type="checkbox"]')
                .forEach((checkbox) => {
                    checkbox.checked = false;
                });
            setTimeout(() => {
                this.shopOnlineFilter.querySelector(`input[value="${this.store}"]`).click();
            }, 500);
        } else if (storeAvailability == 'view') {
            this.shopOnlineFilter.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
                checkbox.checked = false;
            });
            setTimeout(() => {
                this.viewInStoreFilter.querySelector(`input[value="${this.store}"]`).click();
            }, 500);
        }

        // Close Filter in mobile
        this.yourStoreModal.hideMobileFilterDrawer();
    }

    /**
     * Hides the loading indicator.
     *
     * @returns {void}
     */
    hideLoadingIndicator() {
        // Hide the loading indicator after 500ms
        setTimeout(() => {
            this.loadingIndicator.classList.remove('visible');
        }, 500);
    }

    resetToAll() {
        // Get the updated value
        this.way = localStorage.getItem('storeWay');

        if (this.way != 'all') return;

        // Remove the local storage variables storeLocation, storeAvailability, storeWay, and storeState
        localStorage.removeItem('storeState');
        localStorage.removeItem('storeAvailability');

        // Remove checked in hidden filters
        this.initHiddenFilters();
        this.shopOnlineFilter.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
            checkbox.checked = false;
        });
        this.viewInStoreFilter.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
            checkbox.checked = false;
        });
        this.shippableFilter.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
            checkbox.checked = false;
        });

        setTimeout(() => {
            this.resetAllButton.click();
        }, 500);

        const headerModalOpener = document.querySelector('.header__your-store-opener');
        if (headerModalOpener) {
            headerModalOpener.querySelector('button').setAttribute('data-way', 'all');
        }

        // Close Filter in mobile
        this.yourStoreModal.hideMobileFilterDrawer();
    }

    setActiveWayInFacet() {
        // Get the updated value
        this.way = localStorage.getItem('storeWay') || 'all';

        this.wayButtons.forEach((button) => {
            button.classList.remove('active-way');
            if (button.dataset.way == this.way) {
                button.classList.add('active-way');
            } else {
                button.classList.remove('active-way');
            }
        });

        if (!this.availability) return;
        this.querySelector(`.active-option`).classList.remove('active-option');
        this.querySelector(
            `.facet-way__radio[data-store-availability="${this.availability}"]`
        ).classList.add('active-option');

        this.setSelectedStoreInFacet();
        this.updateRemoveAllUrl();
    }

    updateRemoveAllUrl() {
        const removeAllLinks = document.querySelectorAll('[data-filter-remove-all]');

        // Return early if no links are found
        if (removeAllLinks.length === 0) return;

        const url = new URL(window.location.href);
        const paramsToCheck = [
            'filter.v.m.p80.pickup_in_store',
            'filter.v.m.p80.view_in_store',
            'filter.v.m.p80.shippable_quantity_boolean'
        ];

        // Loop through all links
        removeAllLinks.forEach((link) => {
            let newUrl = new URL(link.href);

            // Loop through the parameters and add them if they exist in the current URL
            paramsToCheck.forEach((param) => {
                if (url.searchParams.has(param)) {
                    newUrl.searchParams.set(param, url.searchParams.get(param));
                }
            });

            link.href = newUrl.toString();
        });
    }

    setSelectedStoreInFacet() {
        const headerModalOpener = document.querySelector('.header__your-store-opener');
        if (!headerModalOpener) return;

        const storeName = localStorage.getItem('storeLocation');
        const storeStatus = headerModalOpener.querySelector('.your-store-status').textContent;

        const allStoreFacet = Array.from(document.querySelectorAll('your-store-facet'));
        allStoreFacet.forEach((facet) => {
            facet.querySelector('[data-facet-current-store]').textContent = storeName;
            facet.querySelector('.your-store-name').textContent = storeName;
            facet.querySelector('.your-store-status').dataset.status = storeStatus;
            facet.querySelector('.your-store-status').textContent = storeStatus;
        });
    }

    setFacetCounts() {
        // Get the current URL and strip the parameters
        const url = new URL(window.location.href);
        let currentUrl = url.pathname + '?view=filter-counts';

        if (url.pathname === '/search') {
            const searchParams = new URLSearchParams(url.search);
            const qParam = searchParams.get('q');
            if (qParam) {
                currentUrl += '&q=' + qParam;
            }
        }

        const facetShopAllCount = this.querySelector('span[data-facet-shop-all]');
        const facetShipToYouCount = this.querySelector('span[data-facet-ship-to-you]');
        const facetPickupCount = this.querySelector('span[data-facet-pickup]');
        const facetViewCount = this.querySelector('span[data-facet-view]');
        const facetYourStoreCount = this.querySelector('span[data-facet-your-store]');

        // Fetch JSON data from the constructed URL
        fetch(currentUrl)
            .then((response) => response.json())
            .then((data) => {
                // Inject the value from "facet-shop-all"
                facetShopAllCount.textContent = `(${data['facet-shop-all']})`;

                // Inject the value from "facet-ship-to-you['Yes']"
                facetShipToYouCount.textContent = `(${data['facet-ship-to-you']['Yes']})`;

                // Handle currentLocation
                let currentLocation = this.store;

                if (
                    !currentLocation ||
                    !data['facet-pickup'][currentLocation] ||
                    !data['facet-view'][currentLocation]
                ) {
                    facetPickupCount.textContent = `(0)`;
                    facetViewCount.textContent = `(0)`;
                    facetYourStoreCount.textContent = `(${data['facet-shop-all']})`;
                } else {
                    let pickupCount = data['facet-view'][currentLocation];
                    let viewCount = data['facet-pickup'][currentLocation];

                    facetPickupCount.textContent = pickupCount;
                    facetViewCount.textContent = viewCount;

                    let maxCount = Math.max(pickupCount, viewCount);
                    facetYourStoreCount.textContent = `(${maxCount})`;
                }
            })
            .catch((error) => {
                console.error('Error fetching or processing JSON data:', error);
            });
    }
}

customElements.define('your-store-facet', YourStoreFacet);

class YourStoreModalOpener extends ModalOpener {
    constructor() {
        super();

        // Loading indicator
        this.loadingIndicator = this.querySelector('.your-store-modal__loader');

        // Notice
        this.notice = this.querySelector('.your-store-modal__info');

        if (!this.notice) return;
        this.noticeClose = this.notice.querySelector('button');
        this.noticeClose.addEventListener('click', () => {
            this.hideNotice(true);
        });
    }

    /**
     * Binds the click event listener to the modal opener button.
     * When the button is clicked, it triggers the handleClick method.
     */
    bind() {
        const yourStoreButton = this.querySelector('button.your-store-modal__button');
        if (!yourStoreButton) return;

        yourStoreButton.addEventListener('click', this.handleClick.bind(this));

        const yourStoreLegendButton = this.querySelector('button.your-store-modal__legend');
        if (!yourStoreLegendButton) return;

        yourStoreLegendButton.addEventListener('click', this.handleLegendClick.bind(this));
    }

    handleLegendClick(event) {
        const target = event.target;
        const modal = document.querySelector(target.getAttribute('data-modal'));
        if (!modal) return;
        modal.show(target);
    }

    /**
     * Handles the click event on the modal opener button.
     * It shows the associated modal and restores the saved selections in the 'your-store-modal' element.
     *
     * @param {Event} event - The click event object.
     */
    handleClick(event) {
        if (this.notice) this.hideNotice(true);

        const modal = document.querySelector(this.getAttribute('data-modal'));
        if (!modal) return;
        modal.show(event.target);

        const yourStoreModal = modal.querySelector('your-store-modal');
        if (!yourStoreModal) return;
        yourStoreModal.restoreSavedSelections();
    }

    /**
     * Hides the loading indicator from the modal opener.
     *
     * @returns {void}
     */
    hideLoadingIndicator() {
        // Hide the loading indicator after 500ms
        setTimeout(() => {
            this.loadingIndicator.classList.remove('visible');
        }, 500);
    }

    updatePDPAvailability() {
        const storePickupEl = this.closest('.product__store-pickup');
        if (!storePickupEl) return;
        const activeVariant = storePickupEl.querySelector('.store-pickup_data--active');
        if (!activeVariant) return;
        const savedStore = localStorage.getItem('storeLocation');
        if (!savedStore) return;
        const selectedStore = activeVariant.querySelector(`[data-name="${savedStore}"]`);
        if (!selectedStore) return;
        const storeAvailability = selectedStore.querySelector('[data-status]');
        if (!storeAvailability) return;

        const clonedChild = storeAvailability.cloneNode(true);
        const currentAvailability = document.querySelector('.your-store-availability');
        while (currentAvailability.firstChild) {
            currentAvailability.removeChild(currentAvailability.firstChild);
        }
        if (clonedChild.getAttribute('data-alt-status')) {
            clonedChild.textContent = clonedChild.getAttribute('data-alt-status');
        }
        currentAvailability.appendChild(clonedChild);
    }

    updatePDPSelectedStore() {
        const storePickupEl = this.closest('.product__store-pickup');
        if (!storePickupEl) return;
        const savedStore = localStorage.getItem('storeLocation');
        if (!savedStore) return;
        const allItems = document.querySelectorAll('state-inventory-item');
        if (!allItems) return;
        allItems.forEach((item) => {
            const itemRadio = item.querySelector('input[type="radio"]');
            if (itemRadio) {
                // Remove checked attribute from all radios
                itemRadio.removeAttribute('checked');

                // Add checked attribute to radios with the same value
                if (itemRadio.value == savedStore) {
                    itemRadio.setAttribute('checked', 'checked');
                }
            }
        });
    }

    updatePDPPickupNotice() {
        const productInfo = this.closest('product-info');
        if (!productInfo) return;

        const currentVariantId = productInfo.querySelector('[name="id"]').value;

        const pickupOnlyEl = productInfo.querySelectorAll('.product__pickup-only');

        if (!pickupOnlyEl) return;

        pickupOnlyEl.forEach((elem) => {
            elem.classList.add('hidden');
        });

        const savedStore = localStorage.getItem('storeLocation');
        if (!savedStore) return;

        const pickupOnlyElCurrent = productInfo.querySelector(
            `.product__pickup-only[data-variant="${currentVariantId}"]`
        );
        if (!pickupOnlyElCurrent) return;

        const pickupOnlyStores = pickupOnlyElCurrent.dataset.stores;
        if (pickupOnlyStores.trim() == '') return;

        if (!pickupOnlyStores.includes(savedStore)) return;

        pickupOnlyElCurrent.classList.remove('hidden');
    }

    showNotice() {
        let parent = this.notice;
        let progress = parent.querySelector('[data-progress]');
        this.notice.classList.add('show');

        // Force reflow
        progress.offsetHeight;

        parent.classList.add('start-anim');

        // Trigger hideNotice after 5 seconds
        setTimeout(() => {
            this.hideNotice();
        }, 3000);
    }

    hideNotice(quick = false) {
        if (quick) {
            this.notice.classList.remove('show', 'start-anim', 'fade-out');
        } else {
            this.notice.classList.add('fade-out'); // Wait for the transition to complete before hiding the element
            setTimeout(() => {
                this.notice.classList.remove('show', 'start-anim', 'fade-out');
            }, 300);
        }
    }
}

customElements.define('your-store-modal-opener', YourStoreModalOpener);

class YourStoreModal extends HTMLElement {
    /**
     * Constructor for the YourStoreModal custom element.
     * Initializes the component by setting default values for this.way, this.state, and this.store.
     * It also sets up event listeners for the way, state, and store buttons, save button, and closes the modal.
     * It also initializes the modal opener and location filter.
     */
    constructor() {
        super();
        this.yourStoreFacet = document.querySelector('your-store-facet');

        // Check local storage for 'storeWay', default to 'all' if not found
        this.way = localStorage.getItem('storeWay') || 'all';

        // Check local storage for 'storeState', default to 'MN' if not found
        this.state = localStorage.getItem('storeState') || 'MN';

        // Check local storage for 'storeLocation', default to null if not found
        this.store = localStorage.getItem('storeLocation') || null;

        // Check local storage for 'storeAvailability', default to pickup if not found
        this.availability = localStorage.getItem('storeAvailability') || 'pickup';

        // Convert NodeList to Array
        this.wayButtons = Array.from(this.querySelectorAll('[data-way]'));
        this.stateButtons = Array.from(this.querySelectorAll('[data-state]'));
        this.storeRadioButtons = Array.from(this.querySelectorAll('[data-pickup-store]'));

        // Add event listeners to the way buttons
        this.wayButtons.forEach((button) => {
            button.addEventListener('click', this.handleWayClick.bind(this));
        });

        // Add event listeners to the state buttons
        this.stateButtons.forEach((button) => {
            button.addEventListener('click', this.handleStateClick.bind(this));
        });

        // Add event listeners to the store radio buttons
        this.storeRadioButtons.forEach((radioButton) => {
            radioButton.addEventListener('click', this.handleStoreClick.bind(this));
        });

        // Get the close button
        this.closeButton = this.querySelector('[data-close-store-modal]');

        // Get the modal opener and convert NodeList to Array
        this.modalOpener = Array.from(document.querySelectorAll('[data-store-modal-opener]'));

        // Get the location filter
        // this.locationFilter = document.querySelector(
        //     'details[data-name="store-pick-up-availability"]'
        // );

        // Get the 'Shop Online, Pickup in Store' filter
        this.shopOnlineFilter = document.querySelector(
            'details[data-name="shop-online-pickup-in-store"]'
        );

        // Get the 'View in Store' filter
        this.viewInStoreFilter = document.querySelector('details[data-name="view-in-store"]');

        // Get the 'Shippable Has Quantity' filter
        this.shippableFilter = document.querySelector(
            'details[data-name="shippable-has-quantity"]'
        );

        // Get the alert bar
        this.alertBar = document.querySelector('.product-grid-container__alert');

        // Store hours
        this.storeHours = p80.storeHours || {};

        // Location detail store status
        this.locationStatus = document.querySelector('.p80-location_hours-status');

        this.locationsJson = document.querySelector('#LocationsJSON');

        // Check if this.store becomes null in an unknown way
        if ((this.store == 'null' || !this.store) && this.way !== 'online') {
            localStorage.removeItem('storeWay');
            localStorage.removeItem('storeState');
            this.way = 'all';
            this.state = 'MN';
        }

        // Set filters from URL
        this.setFilters();

        // Initialize the component based on the current values of this.way, this.state, and this.store
        this.initialize();
    }

    setFilters() {
        // No need to proceed if this.way is online
        if (this.way == 'online' || this.way == 'all') return;

        // Get the current URL
        const currentUrl = new URL(window.location.href);
        let availability = null;

        if (currentUrl.searchParams.has('filter.v.m.p80.pickup_in_store')) {
            availability = 'view';
        } else if (currentUrl.searchParams.has('filter.v.m.p80.view_in_store')) {
            availability = 'pickup';
        } else {
            return;
        }

        // Get the pickup and view parameter value
        const currentParam =
            availability == 'view'
                ? currentUrl.searchParams.get('filter.v.m.p80.pickup_in_store')
                : currentUrl.searchParams.get('filter.v.m.p80.view_in_store');

        // Return early if the location parameter matches this.store
        if (currentParam === this.store) return;

        // Extract state from locationParam (assumes format "City, STATE")
        const state = currentParam.split(', ')[1];

        // Set localStorage values
        localStorage.setItem('storeWay', 'pickup');
        localStorage.setItem('storeLocation', currentParam);
        localStorage.setItem('storeAvailability', availability);
        localStorage.setItem('storeState', state);
    }

    /**
     * Initializes the component based on the current values of this.way, this.state, and this.store.
     * Finds the corresponding buttons and radio buttons based on the current values and clicks them.
     * Then, it updates the modal opener and location filter.
     *
     * @returns {void}
     */
    initialize() {
        // Find the button with the matching 'data-way' attribute value and click it
        const wayButton = this.wayButtons.find(
            (button) => button.getAttribute('data-way') === this.way
        );
        // wayButton.click();
        if (wayButton) {
            wayButton.classList.remove('button--secondary');
            wayButton.classList.add('button--primary');
        }

        // If the selected way is 'pickup', find the button with the matching 'data-state' attribute value and click it
        if (this.way === 'pickup') {
            // Remove 'button--primary' class and add 'button--secondary' class to all stateButtons
            this.stateButtons.forEach((button) => {
                button.classList.remove('button--primary');
                button.classList.add('button--secondary');
            });

            const stateButton = this.stateButtons.find(
                (button) => button.getAttribute('data-state') === this.state
            );
            // stateButton.click();
            if (stateButton) {
                stateButton.classList.remove('button--secondary');
                stateButton.classList.add('button--primary');
            }

            // Uncheck all storeRadioButtons
            this.storeRadioButtons.forEach((radioButton) => {
                radioButton.checked = false;
            });

            if (!this.store) return;

            // Find the radio button with the matching 'value' attribute value and click it
            const storeRadioButton = this.storeRadioButtons.find(
                (radioButton) => radioButton.value === this.store
            );
            // if (!storeRadioButton) return;
            // storeRadioButton.click();
            if (storeRadioButton) {
                storeRadioButton.checked = true;
            }
        }

        // Update the modal opener
        this.updateModalOpener();

        // Set the store status
        this.setStoreStatus();

        // Update the alert bar in the collection page
        if (this.way != 'all') {
            this.updateAlertBar();
        }

        // Get the current URL
        const currentUrl = new URL(window.location.href);
        // Update the location filter in the collection page
        if (
            this.store !== null &&
            !currentUrl.searchParams.has('filter.v.m.p80.pickup_in_store') &&
            !currentUrl.searchParams.has('filter.v.m.p80.view_in_store')
        ) {
            this.updateLocationFilter();
        }

        if (this.yourStoreFacet) {
            // Set active way in the facet
            this.yourStoreFacet.setActiveWayInFacet();

            // Set selected Store in the facet
            this.yourStoreFacet.setSelectedStoreInFacet();
        }

        // Set the status in location detail page
        this.setLocationStatus();
    }

    /**
     * Handles the way click event.
     * Updates the value of this.way based on the selected button.
     *
     * @param {Event} event - The click event.
     * @returns {void}
     */
    handleWayClick(event) {
        // Get the parent div of the clicked button
        const parentWay = event.target.closest('div');

        // Find the currently active button with 'button--primary' class
        const activeButton = parentWay.querySelector('.button--primary');

        // If there is an active button, remove 'button--primary' and add 'button--secondary'
        if (activeButton) {
            activeButton.classList.remove('button--primary');
            activeButton.classList.add('button--secondary');
        }

        // Remove 'button--secondary' from the clicked button and add 'button--primary'
        event.target.classList.remove('button--secondary');
        event.target.classList.add('button--primary');

        // Get the data-way attribute value of the clicked button
        const way = event.target.getAttribute('data-way');

        // Update the this.way variable with the new way value
        this.way = way;

        // Save selection if not 'pickup'
        if (this.way != 'pickup') {
            this.handleSaveClick();
        }
    }

    /**
     * Handles the state click event.
     * Updates the value of this.state based on the selected button.
     *
     * @param {Event} event - The click event.
     * @returns {void}
     */
    handleStateClick(event) {
        // Get the parent div of the clicked button
        const parentStates = event.target.closest('div');

        // Find the currently active button with 'button--primary' class
        const activeButton = parentStates.querySelector('.button--primary');

        // If there is an active button, remove 'button--primary' and add 'button--secondary'
        if (activeButton) {
            activeButton.classList.remove('button--primary');
            activeButton.classList.add('button--secondary');
        }

        // Remove 'button--secondary' from the clicked button and add 'button--primary'
        event.target.classList.remove('button--secondary');
        event.target.classList.add('button--primary');

        // Get the data-state attribute value of the clicked button
        const state = event.target.getAttribute('data-state');

        // Update the this.state variable with the new way value
        this.state = state;
    }

    /**
     * Handles the store click event.
     * Updates the value of this.store based on the selected radio button.
     *
     * @param {Event} event - The click event.
     * @returns {void}
     */
    handleStoreClick(event) {
        // Get the value of the clicked radio button
        const store = event.target.value;

        // Update the value of this.store
        this.store = store;

        // Save selection if not 'pickup'
        if (this.way == 'pickup') {
            this.handleSaveClick();
        }
    }

    /**
     * Handles the save button click event.
     * Saves the selected store way, state, and location in local storage.
     * Closes the modal, updates the modal opener, and updates the location filter.
     */
    handleSaveClick() {
        // Save the storeWay variable in local storage with the value of this.way
        localStorage.setItem('storeWay', this.way);

        // Check if the this.way value is "pickup"
        if (this.way === 'pickup') {
            // Save the storeState variable in local storage with the value of this.state
            localStorage.setItem('storeState', this.state);

            // Save the storeLocation variable in local storage with the value of this.store
            localStorage.setItem('storeLocation', this.store);

            // Save the storeAvailability variable in local storage with the value of this.availability
            localStorage.setItem('storeAvailability', this.availability);

            this.updateLocationDetails();
        } else {
            // Remove the storeState variable from local storage
            localStorage.removeItem('storeState');

            // Remove the storeAvailability variable from local storage
            localStorage.removeItem('storeAvailability');

            if (this.way == 'all' && this.yourStoreFacet) {
                this.yourStoreFacet.querySelector('.facet-way__button[data-way="all"]').click();
            }
        }

        // Close the modal
        this.closest('modal-dialog').hide();

        // Close Filter in mobile
        this.hideMobileFilterDrawer();

        // Show notice in modal opener
        this.showSuccessNotice();

        // Prevent updating facets and store selector in header
        // if no state is selected
        const storeRadioButton = this.storeRadioButtons.find(
            (radioButton) => radioButton.value === this.store
        );
        if (this.way === 'pickup' && !storeRadioButton) {
            return false;
        }

        // Update the modal opener
        this.updateModalOpener();

        // Update the alert bar in the collection page
        this.updateAlertBar();

        // Update the location filter
        this.updateLocationFilter();

        // Set the status in location detail page
        this.setLocationStatus();
    }

    updateLocationDetails() {
        // Check if locationsJson element exists
        if (!this.locationsJson) return;

        // Parse the JSON inside locationsJson
        let locJson;
        try {
            locJson = JSON.parse(this.locationsJson.textContent);
        } catch (e) {
            console.error('Invalid Locations JSON', e);
            return;
        }

        // Find the object with 'name' equals to this.store
        const storeObj = locJson.find((loc) => loc.name === this.store);
        if (!storeObj) return;

        // Loop through each modal opener and update details
        this.modalOpener.forEach((modalOpenerEl) => {
            const storeDetailsEl = modalOpenerEl.querySelector('[data-store-details]');
            if (!storeDetailsEl) return;

            // Get the detail elements
            const addressEl = storeDetailsEl.querySelector('[data-details-address]');
            const phoneEl = storeDetailsEl.querySelector('[data-details-phone]');
            const scheduleEl = storeDetailsEl.querySelector('[data-details-schedule]');
            const infoUrlEl = storeDetailsEl.querySelector('[data-details-info-url]');
            const directionsUrlEl = storeDetailsEl.querySelector('[data-details-directions-url]');

            // Inject values if elements exist
            if (addressEl) addressEl.innerHTML = storeObj.address.replace(/\n/g, '<br>');
            if (phoneEl) phoneEl.textContent = storeObj.phone;

            // Format store_hours as HTML blocks per day
            if (scheduleEl && storeObj.store_hours) {
                // Split by newline, then by '|'
                const lines = storeObj.store_hours.split('\n');
                let html = '';
                lines.forEach((line) => {
                    const [day, hours] = line.split('|');
                    if (day && hours) {
                        html += `<div><span>${day.trim()}</span><span>${hours.trim()}</span></div>`;
                    }
                });
                scheduleEl.innerHTML = html;
            }

            if (infoUrlEl) infoUrlEl.href = storeObj.location_url;
            if (directionsUrlEl) directionsUrlEl.href = storeObj.directions_url;
        });
    }

    hideMobileFilterDrawer() {
        const drawer = document.querySelector('.mobile-facets__disclosure');
        const body = document.querySelector('body');
        if (!drawer) return;
        drawer.removeAttribute('open');
        drawer.classList.remove('menu-opening');
        body.classList.remove('overflow-hidden-mobile');
        body.removeAttribute('style');
    }

    showSuccessNotice() {
        // Check if modalOpener is defined
        if (!this.modalOpener) return;

        // Iterate over each modalOpener element
        this.modalOpener.forEach((modalOpener) => {
            const notice = modalOpener.querySelector('.your-store-modal__info');

            // Check if the way is 'pickup' and a store is selected
            if (notice) {
                modalOpener.showNotice();
            }
        });
    }

    /**
     * Updates the modal opener based on the current state of the component.
     * If the way is 'pickup' and a store is selected, it hides the store select dropdown
     * and displays the selected store name. Otherwise, it shows the store select dropdown
     * and clears the store name.
     *
     * @returns {void}
     */
    updateModalOpener() {
        // Check if modalOpener is defined
        if (!this.modalOpener) return;

        const storeHours = this.storeHours;

        // Iterate over each modalOpener element
        this.modalOpener.forEach((modalOpener, index) => {
            // Get the store select dropdown and store name elements
            const button = modalOpener.querySelector('button');
            const storeSelect = modalOpener.querySelector('.your-store-select');
            const storeName = modalOpener.querySelector('.your-store-name');
            const storeStatus = modalOpener.querySelector('.your-store-status');

            // Check if the way is 'pickup' and a store is selected
            if (this.way === 'pickup' && this.store !== null) {
                // Hide the store select dropdown and display the selected store name
                if (storeSelect) storeSelect.classList.add('hidden');
                storeName.textContent = this.store;
                if (Object.keys(storeHours).length > 0 && storeStatus) {
                    storeStatus.textContent = storeHours[this.store];
                    storeStatus.setAttribute('data-status', storeHours[this.store]);
                }
                this.updateLocationDetails();
            } else {
                // Show the store select dropdown and clear the store name
                if (storeSelect) storeSelect.classList.remove('hidden');
                storeName.textContent = '';
                if (storeStatus) {
                    storeStatus.textContent = '';
                    storeStatus.removeAttribute('data-status');
                }
            }

            // Header specific store selector
            if (modalOpener.classList.contains('header__your-store-opener')) {
                button.setAttribute('data-way', this.way);
            }

            // PDP specific events
            if (modalOpener.closest('.product__store-pickup')) {
                modalOpener.updatePDPAvailability();
                modalOpener.updatePDPSelectedStore();
                modalOpener.updatePDPPickupNotice();
            }

            // Hide the loading indicator
            modalOpener.hideLoadingIndicator();
        });
    }

    /**
     * Updates the location filter based on the current state of the component.
     * If the way is 'pickup' and a store is selected, it checks the corresponding checkbox
     * in the location filter. If the way is 'online', it unchecks all checkboxes.
     *
     * @returns {void}
     */
    updateLocationFilter() {
        // Check if shopOnlineFilter or viewInStoreFilter is defined
        if (!this.shopOnlineFilter && !this.viewInStoreFilter) return;

        let availabilityCheckbox = null;

        // Check store is selected
        if (this.way == 'pickup') {
            availabilityCheckbox = this.selectDefaultPickupInStore();
        }

        // Get the current URL
        const currentUrl = new URL(window.location.href);

        // If a checkbox is selected, click it
        if (
            currentUrl.searchParams.has('filter.v.m.p80.shippable_quantity_boolean') &&
            this.way == 'pickup'
        ) {
            this.shippableFilter.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
                checkbox.checked = false;
            });
            setTimeout(() => {
                this.shopOnlineFilter.querySelector(`input[value="${this.store}"]`).click();
            }, 500);
        } else if (availabilityCheckbox) {
            availabilityCheckbox.click();
        } else if (this.way == 'online') {
            this.yourStoreFacet.handleOnline();
        } else {
            console.warn('else:updateLocationFilter');
        }

        this.yourStoreFacet.setActiveWayInFacet();
    }

    selectDefaultPickupInStore() {
        if (!this.availability) return;

        this.viewInStoreFilter.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
            checkbox.checked = false;
        });
        this.shopOnlineFilter.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
            checkbox.checked = false;
        });

        const availabilityOptions =
            this.availability == 'pickup' ? this.shopOnlineFilter : this.viewInStoreFilter;

        // Early return if availabilityOptions doesn't exist and storeAvailability has a value
        if (!availabilityOptions) return null;

        availabilityOptions
            .querySelectorAll('input[type="checkbox"]:checked')
            .forEach((input) => (input.checked = false));

        // Check for input with value matching this.store
        const storeInput = availabilityOptions.querySelector(`input[value="${this.store}"]`);

        return storeInput;
    }

    updateAlertBar(update = null) {
        // Get the current URL
        const currentUrl = new URL(window.location.href);
        if (update) {
            this.alertBar = document.querySelector('.product-grid-container__alert');
        }

        this.way = localStorage.getItem('storeWay');
        this.store = localStorage.getItem('storeLocation');

        if (!this.alertBar) return;
        this.alertBar.classList.add('hidden');
        this.alertBar.removeAttribute('data-way');

        if (!this.store && this.way != 'online') return;

        if (
            !currentUrl.searchParams.has('filter.v.m.p80.pickup_in_store') &&
            !currentUrl.searchParams.has('filter.v.m.p80.view_in_store') &&
            !currentUrl.searchParams.has('filter.v.m.p80.shippable_quantity_boolean')
        )
            return;

        this.alertBar.setAttribute('data-way', this.way);

        this.alertBar.querySelector('button').addEventListener('click', (event) => {
            event.preventDefault();
            if (!this.modalOpener[0]) return;
            this.modalOpener[0].querySelector('button').click();
        });

        this.alertBar.querySelector('[data-current-store]').textContent = this.store;
        this.alertBar.classList.remove('hidden');
    }

    /**
     * Restores the saved selections from local storage and updates the corresponding UI elements.
     * This method is called when the 'your-store-modal' element is created.
     *
     * @returns {void}
     */
    restoreSavedSelections() {
        // Check local storage for 'storeWay'
        const savedWay = localStorage.getItem('storeWay');

        // Remove 'button--primary' class and add 'button--secondary' class to all wayButtons
        if (savedWay) {
            this.wayButtons.forEach((button) => {
                button.classList.remove('button--primary');
                button.classList.add('button--secondary');
            });
        }

        // Remove 'button--primary' class and add 'button--secondary' class to all stateButtons
        this.stateButtons.forEach((button) => {
            button.classList.remove('button--primary');
            button.classList.add('button--secondary');
        });

        // Uncheck all storeRadioButtons
        this.storeRadioButtons.forEach((radioButton) => {
            radioButton.checked = false;
        });

        // Check local storage for 'storeState'
        const savedState = localStorage.getItem('storeState') || 'MN';

        // Check local storage for 'storeLocation'
        const savedStore = localStorage.getItem('storeLocation');

        // Find the button with the matching 'data-way' attribute value and click it
        const wayButton = this.wayButtons.find(
            (button) => button.getAttribute('data-way') === savedWay
        );
        if (wayButton) {
            wayButton.classList.remove('button--secondary');
            wayButton.classList.add('button--primary');
        }

        // If the saved way is not 'pickup', return early
        // if (savedWay !== 'pickup') return;

        // If there is no saved state, return early
        if (!savedState) return;

        // Find the button with the matching 'data-state' attribute value and click it
        const stateButton = this.stateButtons.find(
            (button) => button.getAttribute('data-state') === savedState
        );
        if (stateButton) {
            stateButton.classList.remove('button--secondary');
            stateButton.classList.add('button--primary');
        }

        // If there is no saved store, return early
        if (!savedStore) return;

        // Find the radio button with the matching 'value' attribute value and click it
        const storeRadioButton = this.storeRadioButtons.find(
            (radioButton) => radioButton.value === savedStore
        );
        if (storeRadioButton) {
            storeRadioButton.checked = true;
        }
    }

    setStoreStatus() {
        const storeHours = this.storeHours;
        if (!Object.keys(storeHours).length) return;
        const stores = this.querySelectorAll('.your-store_modal-pickup-store');
        stores.forEach((store) => {
            if (!store.dataset.name) return;
            if (!storeHours[store.dataset.name]) return;
            if (!store.querySelector('[data-status]')) return;
            store.querySelector('[data-status]').textContent = storeHours[store.dataset.name];
            store
                .querySelector('[data-status]')
                .setAttribute('data-status', storeHours[store.dataset.name]);
        });
    }

    setLocationStatus() {
        if (!this.locationStatus) return;
        const storeHours = this.storeHours;
        const currentLocation = this.locationStatus.dataset.store;
        this.locationStatus.textContent = '';
        this.locationStatus.removeAttribute('data-status');
        if (!currentLocation) return;
        if (!Object.keys(storeHours).length) return;
        this.locationStatus.textContent = `Currently ${storeHours[currentLocation]}`;
        this.locationStatus.setAttribute('data-status', storeHours[currentLocation]);
    }
}

customElements.define('your-store-modal', YourStoreModal);
